import React from 'react'
//@ts-ignore
import add from '../../assets/images/add.png';
const AddIcon = () => {
  return (
    <img src={add} alt="dashboard" height="20" />
  )
}

export default AddIcon